module.exports = __webpack_public_path__ + "static/assets/ad1c36242f47ab80bf56453044883f40.jpg";